import { Injectable } from '@angular/core';
import { CanActivate, Router} from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor( private auth: AuthService, private route: Router){}
   canActivate(): Observable<boolean> | Promise<boolean> | boolean{

    return this.auth.isUserLogedIn.pipe(
      take(1),
      switchMap(isLogedIn=>{
        if(!isLogedIn){
          return from(this.auth.autoLogin());
        }
        return of(isLogedIn);
      }),
      tap(isLogedIn=>{
        if(!isLogedIn){
          this.route.navigate(['/login', { redirect: true }]);
        }
      })
    );
  }

}
